/// <amd-module name="WorkItemsHub/DataContracts/IActionsDataContract" />
import { FilterState } from "Wit/Filter/FilterManager";
import { WorkItemsHubData, WorkItemsHubSortOption } from "WorkItemsHub/Generated/Contracts";
import * as WitCommonContracts from "Wit/Common/Generated/Contracts";

export interface IWorkItemsHubFilterUpdateData {
    tabId: string;
    updatedFilter: FilterState;
}

export interface IWorkItemsHubUpdateData {
    tabId: string;
    tabData: WorkItemsHubData;
}

export interface IWorkItemsHubRemoveWorkItemData {
    tabId: string;
    workItemIds: number[];
}

export interface IWorkItemsHubShowCompletedItemsData {
    tabId: string;
    showCompletedItems: boolean;
}

export interface IWorkItemsHubSortItemsData {
    tabId: string;
    sortOptions: WorkItemsHubSortOption[];
}

export interface IWorkItemsHubPagedWorkItemData {
    tabId: string;
    fieldReferenceNames: string[];
    fieldValuesList: WitCommonContracts.SecuredGenericData[];
}
